var EHDI = EHDI || Object.create(null);

EHDI.component = EHDI.component || Object.create(null);

EHDI.component.Bug = function(texture, color) {
    EHDI.aka.Container.call(this);
    var _this = this;
    var _armature, _animSprite;
    
    
    var _currentColor = color;
    
    var animationTimeline = new TimelineMax();
    
    var sprite = new EHDI.aka.Sprite(texture);
    this.addChild(sprite);
    sprite.anchor.set(0.5);
    
    this.drop = function() {
        animationTimeline.clear();
        animationTimeline.to(_this, 0.75, {y : EHDI.screen.stageHeight + this.height, ease : Power2.easeIn});
        animationTimeline.addCallback(function() {
            _this.destroy({children : true});
        });
    }
    
    this.fly = function() {
        this.rotation = 0;
        if(_currentColor === "blue") {
            this.flyOne();
        } else if(_currentColor === "pink") {
            this.flyTwo();
        } else if(_currentColor === "green") {
            this.flyThree();
        } else if(_currentColor === "purple") {
            this.flyFour();
        } else if(_currentColor === "red") {
            this.flyFive();
        } else if (_currentColor === "yellow") {
            this.flySix();
        }
    }
    
    this.changeBug = function(texture, newColor, callBack) {
        EHDI.GAME.gameScene.bugManager.lockInput = true;
        EHDI.GAME.gameScene.bugManager.changeBug = true;
        var bubbleTrans = new EHDI.aka.Sprite(EHDI.Assets.images["bugout_wildbug_dew"]);
        var xPos = bubbleTrans.width;
        var yPos = bubbleTrans.height;
        var dew1 = new EHDI.aka.Sprite(EHDI.Assets.images["bugout_wildbug_dew_set1"]);
        var dew2 = new EHDI.aka.Sprite(EHDI.Assets.images["bugout_wildbug_dew_set2"]);
        bubbleTrans.scale.set(0);
        bubbleTrans.anchor.set(0.5);
        dew1.anchor.set(1);
        dew2.anchor.set(0, 1);
        dew1.scale.set(1, -1);
        dew2.scale.set(1, -1);
        dew1.alpha = 0;
        dew2.alpha = 0;
        _this.addChild(bubbleTrans);
        _this.addChild(dew1);
        _this.addChild(dew2);
        animationTimeline.clear();
        animationTimeline.to(bubbleTrans.scale, 0.2, {x : 1, y : 1});
        animationTimeline.addCallback(function() {
            sprite.texture = texture;
            _currentColor = newColor;
            bubbleTrans.texture = EHDI.Assets.images["bugout_fx_sparkles_blue"];
        });
        animationTimeline.to(dew1, 0.15, {x : -xPos * 0.5, y : yPos * 0.5, alpha : 1})
        animationTimeline.to(dew2, 0.15, {x : xPos * 0.5, y : yPos * 0.5, alpha : 1}, "-=0.15")
        animationTimeline.to(bubbleTrans, 0.3, {alpha : 0});
        animationTimeline.to(dew2, 0.3, {alpha : 0}, "-=0.3")
        animationTimeline.to(dew1, 0.3, {alpha : 0}, "-=0.3")
        animationTimeline.addCallback(function() {
            if(callBack) {
                callBack();
            }
            
            EHDI.GAME.gameScene.bugManager.changeBug = false;
            EHDI.GAME.gameScene.bugManager.lockInput = false;
            bubbleTrans.destroy({children : true});
        });
    }

    
    this.flyOne = function() {
        var curPosX = _this.position.x;
        var curPosY = _this.position.y;
        
        sprite.visible = false;
        
        _armature = EHDI.DBoneFactory.createArmature("bug_" + _currentColor);
        dragonBones.WorldClock.clock.add(_armature);
        _animSprite = _armature.getDisplay();
        _this.addChild(_animSprite);

        _armature.animation.gotoAndPlay("spread", -1, -1, 1);
        animationTimeline.clear();
        animationTimeline.to(_this, 0.1, {x: curPosX + 27.09, y : curPosY + 15.69, rotation : EHDI.NumberUtil.degreeToRadian(-81.3), ease : Power0.easeNone}, "+=0.3");
        animationTimeline.addCallback(function() {
            EHDI.GAME.soundManager.playSFX("bugfly");
            _armature.animation.gotoAndPlay("flight", -1, -1, 0);
        }, "-=0.1");
        animationTimeline.to(_this, 0.133, {x: curPosX + 57.57, y : curPosY - 25.12, rotation : EHDI.NumberUtil.degreeToRadian(-169.93), ease : Power0.easeNone});
        animationTimeline.to(_this, 0.267, {x: curPosX + 57.57, y : curPosY - 118.37, rotation : EHDI.NumberUtil.degreeToRadian(-178.72), alpha : 0, ease : Power0.easeNone});
//        animationTimeline.to(_this, 0.75, {alpha : 0}, "-=0.75");
        animationTimeline.addCallback(function() {
            _this.dispose();
        });
    }
    
    this.flyTwo = function() {
        var curPosX = _this.position.x;
        var curPosY = _this.position.y;
        
        sprite.visible = false;
        
        _armature = EHDI.DBoneFactory.createArmature("bug_" + _currentColor);
        dragonBones.WorldClock.clock.add(_armature);
        _animSprite = _armature.getDisplay();
        _this.addChild(_animSprite);

        _armature.animation.gotoAndPlay("spread", -1, -1, 1);
        animationTimeline.clear();
        animationTimeline.to(_this, 0.1, {x: curPosX - 16.25, y : curPosY + 12.81, rotation : EHDI.NumberUtil.degreeToRadian(62.95), ease : Power0.easeNone}, "+=0.3");
        animationTimeline.addCallback(function() {
            EHDI.GAME.soundManager.playSFX("bugfly");
            _armature.animation.gotoAndPlay("flight", -1, -1, 0);
        }, "-=0.1");
        animationTimeline.to(_this, 0.133, {x: curPosX - 42.98, y : curPosY - 9.84, rotation : EHDI.NumberUtil.degreeToRadian(167.82), ease : Power0.easeNone});
        animationTimeline.to(_this, 0.133, {x: curPosX - 2.97, y : curPosY - 43.68, rotation : EHDI.NumberUtil.degreeToRadian(-113.68), ease : Power0.easeNone});
        animationTimeline.to(_this, 0.133, {x: curPosX + 30.46, y : curPosY - 91.31, rotation : EHDI.NumberUtil.degreeToRadian(-147.02), alpha : 0.5, ease : Power0.easeNone});
        animationTimeline.to(_this, 0.133, {x: curPosX - 18.05, y : curPosY - 141.98, rotation : EHDI.NumberUtil.degreeToRadian(-122.26), alpha : 0, ease : Power0.easeNone});
//        animationTimeline.to(_this, 0.75, {alpha : 0}, "-=0.75");
        animationTimeline.addCallback(function() {
            _this.dispose();
        });
    }
    
    this.flyThree = function() {
        var curPosX = _this.position.x;
        var curPosY = _this.position.y;
        
        sprite.visible = false;
        
        _armature = EHDI.DBoneFactory.createArmature("bug_" + _currentColor);
        dragonBones.WorldClock.clock.add(_armature);
        _animSprite = _armature.getDisplay();
        _this.addChild(_animSprite);

        _armature.animation.gotoAndPlay("spread", -1, -1, 1);
        animationTimeline.clear();
        animationTimeline.to(_this, 0.1, {x: curPosX - 18.64, y : curPosY + 22.77, rotation : EHDI.NumberUtil.degreeToRadian(56.37), ease : Power0.easeNone}, "+=0.3");
        animationTimeline.addCallback(function() {
            EHDI.GAME.soundManager.playSFX("bugfly");
            _armature.animation.gotoAndPlay("flight", -1, -1, 0);
        }, "-=0.1");
        animationTimeline.to(_this, 0.133, {x: curPosX - 49.86, y : curPosY - 27.31, rotation : EHDI.NumberUtil.degreeToRadian(166.67), ease : Power0.easeNone});
        animationTimeline.to(_this, 0.267, {x: curPosX - 48.25, y : curPosY - 149.61, rotation : EHDI.NumberUtil.degreeToRadian(177.63), alpha : 0, ease : Power0.easeNone});
//        animationTimeline.to(_this, 0.75, {alpha : 0}, "-=0.75");
        animationTimeline.addCallback(function() {
            _this.dispose();
        });
    }
    
    this.flyFour = function() {
        var curPosX = _this.position.x;
        var curPosY = _this.position.y;
        
        sprite.visible = false;
        
        _armature = EHDI.DBoneFactory.createArmature("bug_" + _currentColor);
        dragonBones.WorldClock.clock.add(_armature);
        _animSprite = _armature.getDisplay();
        _this.addChild(_animSprite);

         _armature.animation.gotoAndPlay("spread", -1, -1, 1);
        animationTimeline.clear();
        animationTimeline.to(_this, 0.1, {x: curPosX + 36.39, y : curPosY + 33.82, rotation : EHDI.NumberUtil.degreeToRadian(-61.43), ease : Power0.easeNone}, "+=0.3");
        animationTimeline.addCallback(function() {
            EHDI.GAME.soundManager.playSFX("bugfly");
            _armature.animation.gotoAndPlay("flight", -1, -1, 0);
        }, "-=0.1");
        animationTimeline.to(_this, 0.133, {x: curPosX + 53.36, y : curPosY - 11.42, rotation : EHDI.NumberUtil.degreeToRadian(153.98), ease : Power0.easeNone});
        animationTimeline.to(_this, 0.133, {x: curPosX + 5.64, y : curPosY - 56.84, rotation : EHDI.NumberUtil.degreeToRadian(106.48), ease : Power0.easeNone});
        animationTimeline.to(_this, 0.133, {x: curPosX - 34.07, y : curPosY - 112.16, rotation : EHDI.NumberUtil.degreeToRadian(-153.46), alpha : 0.5, ease : Power0.easeNone});
        animationTimeline.to(_this, 0.133, {x: curPosX + 33.62, y : curPosY - 179.89, rotation : EHDI.NumberUtil.degreeToRadian(-125.43), alpha : 0, ease : Power0.easeNone});
//        animationTimeline.to(_this, 0.75, {alpha : 0}, "-=0.75");
        animationTimeline.addCallback(function() {
            _this.dispose();
        });
    }
    
    this.flyFive = function() {
        var curPosX = _this.position.x;
        var curPosY = _this.position.y;
        
        sprite.visible = false;
        
        _armature = EHDI.DBoneFactory.createArmature("bug_" + _currentColor);
        dragonBones.WorldClock.clock.add(_armature);
        _animSprite = _armature.getDisplay();
        _this.addChild(_animSprite);

        _armature.animation.gotoAndPlay("spread", -1, -1, 1);
        animationTimeline.clear();
        animationTimeline.to(_this, 0.1, {x: curPosX + 22.13, y : curPosY + 27.95, rotation : EHDI.NumberUtil.degreeToRadian(-50.00), ease : Power0.easeNone}, "+=0.3");
        animationTimeline.addCallback(function() {
            EHDI.GAME.soundManager.playSFX("bugfly");
            _armature.animation.gotoAndPlay("flight", -1, -1, 0);
        }, "-=0.1");
        animationTimeline.to(_this, 0.1, {x: curPosX + 54.16, y : curPosY + 20.44, rotation : EHDI.NumberUtil.degreeToRadian(-171.10), ease : Power0.easeNone});
        animationTimeline.to(_this, 0.1, {x: curPosX + 42.51, y : curPosY - 33.08, rotation : EHDI.NumberUtil.degreeToRadian(113.03), ease : Power0.easeNone});
        animationTimeline.to(_this, 0.1, {x: curPosX - 13.34, y : curPosY - 41.35, rotation : EHDI.NumberUtil.degreeToRadian(76.77), ease : Power0.easeNone});
        animationTimeline.to(_this, 0.1, {x: curPosX - 37.79, y : curPosY - 5.12, rotation : EHDI.NumberUtil.degreeToRadian(39.65), ease : Power0.easeNone});
        animationTimeline.to(_this, 0.1, {x: curPosX - 23.82, y : curPosY + 38.55, rotation : EHDI.NumberUtil.degreeToRadian(35.12), alpha : 0, ease : Power0.easeNone});
//        animationTimeline.to(_this, 0.75, {alpha : 0}, "-=0.75");
        animationTimeline.addCallback(function() {
            _this.dispose();
        });
    }
    
    this.flySix = function() {
        var curPosX = _this.position.x;
        var curPosY = _this.position.y;
        
        sprite.visible = false;
        
        _armature = EHDI.DBoneFactory.createArmature("bug_" + _currentColor);
        dragonBones.WorldClock.clock.add(_armature);
        _animSprite = _armature.getDisplay();
        _this.addChild(_animSprite);

        _armature.animation.gotoAndPlay("spread", -1, -1, 1);
        animationTimeline.clear();
        animationTimeline.to(_this, 0.1, {x: curPosX - 19.80, y : curPosY + 36.75, rotation : EHDI.NumberUtil.degreeToRadian(33.34), ease : Power0.easeNone}, "+=0.3");
        animationTimeline.addCallback(function() {
            EHDI.GAME.soundManager.playSFX("bugfly");
            _armature.animation.gotoAndPlay("flight", -1, -1, 0);
        }, "-=0.1");
        animationTimeline.to(_this, 0.1, {x: curPosX - 60.39, y : curPosY + 15.78, rotation : EHDI.NumberUtil.degreeToRadian(167.12), ease : Power0.easeNone});
        animationTimeline.to(_this, 0.1, {x: curPosX - 34.77, y : curPosY - 36.46, rotation : EHDI.NumberUtil.degreeToRadian(-132.80), ease : Power0.easeNone});
        animationTimeline.to(_this, 0.1, {x: curPosX + 7.51, y : curPosY - 49.27, rotation : EHDI.NumberUtil.degreeToRadian(-88.32), ease : Power0.easeNone});
        animationTimeline.to(_this, 0.1, {x: curPosX + 44.84, y : curPosY - 27.14, rotation : EHDI.NumberUtil.degreeToRadian(-44.57), ease : Power0.easeNone});
        animationTimeline.to(_this, 0.1, {x: curPosX + 48.34, y : curPosY + 25.22, rotation : EHDI.NumberUtil.degreeToRadian(22.31), alpha : 0, ease : Power0.easeNone});
//        animationTimeline.to(_this, 0.75, {alpha : 0}, "-=0.75");
        animationTimeline.addCallback(function() {
            _this.dispose();
        });
    }
    
    
    
    this.dispose = function() {
        if(EHDI.GAME.gameScene.bugManager.lockInput && !EHDI.GAME.gameScene.bugManager.changeBug) {
            EHDI.GAME.gameScene.bugManager.lockInput = false;
            EHDI.GAME.gameScene.bugManager.checkIfNewRound();
        }
        dragonBones.WorldClock.clock.remove(_armature);
        _this.destroy({children : true});
        _this = null;
    }
}

EHDI.component.Bug.prototype = Object.create(EHDI.aka.Container.prototype);